// extracted by mini-css-extract-plugin
module.exports =  {"root":"PriceDisplayToggle-module__root--Ovr1O","option":"PriceDisplayToggle-module__option--Sv0Yf","active":"PriceDisplayToggle-module__active--dBlfI"};